/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedLogHistoryList } from '../models/PaginatedLogHistoryList';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LogHistoryService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedLogHistoryList
     * @throws ApiError
     */
    public logHistoryList({
        limit,
        offset,
        ordering,
        search,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedLogHistoryList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/log-history/',
            query: {
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'search': search,
            },
        });
    }

}
